var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDeactivated = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Deactivated",
    transform: "translate(-85.22 -229.523)",
    fill: "#c30909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47364",
    "data-name": "Path 47364",
    d: "M91.62,237.291a1.35,1.35,0,1,0,2.693.195,1.322,1.322,0,0,0,0-.178v-6.435a1.347,1.347,0,1,0-2.693,0Z",
    transform: "translate(.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47365",
    "data-name": "Path 47365",
    d: "M101.145,240.664a7.893,7.893,0,0,0-2.567-6.977h0a1.413,1.413,0,0,0-1.958.057,1.364,1.364,0,0,0,.02,1.922.991.991,0,0,0,.077.07,5.115,5.115,0,0,1,1.644,4.712,5.209,5.209,0,1,1-8.642-4.7,1.369,1.369,0,0,0,.176-1.924c-.021-.025-.045-.053-.07-.078a1.419,1.419,0,0,0-1.968-.046,7.9,7.9,0,0,0-2.591,6.709,8,8,0,0,0,2.982,5.376,7.917,7.917,0,0,0,5.9,1.685A8.039,8.039,0,0,0,101.145,240.664Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDeactivated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_Deactivated.8f7b0e56455af018a59014256ad76e3c.svg";